// 生成uuid
export function uuid(len,radix) {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    let uuid = [],
      i;
    radix = radix || chars.length;
  
    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
      let r;
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';
  
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16);
          uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
        }
      }
    }
  
    return uuid.join('');
  }
  // 千分位添加逗号
export const thousands = (num)=>{
  let str = num.toString();
  let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg,"$1,");
}

export function getUrlParam (name) {
  const reg = new RegExp('(^|&)'.concat(name, '=([^&]*)(&|$)'));
  const r = window.location.search.substr(1).match(reg);

  if (r != null) {
      return decodeURIComponent(r[2]);
  } else {
      return null;
  }
}